import { toKebab, toTitleCase } from '@dealerportal/utilities';
type Props = {
  tag: string;
  blogSlug: string;
};

export function ArticleTag(props: Props) {
  return (
    <a
      href={`/${props.blogSlug}/tags/${toKebab(props.tag)}`}
      data-tag={props.tag}
      className="ui-max-w-max ui-block ui-py-1.5 ui-px-3 !ui-text-white ui-font-bold !ui-text-xs ui-rounded-full ui-bg-gray-900 hover:ui-bg-gray-700"
    >
      <span id="articleComponent">{toTitleCase(props.tag)}</span>
    </a>
  );
}
